import { TemplateElement, html, defineElement, unsafeHTML, when } from '@webtides/element-js';
import style from './e-banking-rich-text.css';

/**
 * @property {string} text
 */
export default class RichText extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            text: '',
        };
    }

    template() {
        return html` <div class="richtext">${unsafeHTML(this.text)}</div> `;
    }
}

defineElement('mb-e-banking-rich-text', RichText);
